/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import Loader from './Loader';
import styles from './Button.module.scss';
import '../Utils/css';

/**
 * Simple Button
 */
export default function Button({
  children = null,
  color = 'orange',
  href = null,
  outLine = false,
  size = 'default',
  state = 'default',
  textButton = false,
  disabled = null,
  type = 'button',
  contained = false,
  className = null,
  loading = false,
  ...childProps
}) {
  const classNames = [
    styles.button,
    styles[`--size-${size.toLowerCase()}`],
    styles[`--color-${color.toLowerCase()}`],
    styles[`--state-${state.toLowerCase()}`],
    outLine ? styles['--outline'] : '',
    textButton ? styles['--text'] : '',
    contained ? styles['--contained'] : '',
    className,
  ].css();

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {href ? (
        <a className={classNames} href={href} {...childProps}>
          {loading && (
          <>
            <Loader />
            {' '}
            &nbsp;
          </>
          )}
          {children}
        </a>
      ) : (
        // eslint-disable-next-line react/button-has-type
        <button className={classNames} {...childProps} disabled={disabled} type={type}>
          {loading && (
          <>
            <Loader />
            {' '}
            &nbsp;
          </>
          )}
          {children}
        </button>
      )}
    </>
  );
}

Button.propTypes = {
  /**
   * Button size
   */
  size: PropTypes.oneOf(['default', 'small', 'large']),
  /**
   * Button color
   */
  color: PropTypes.oneOf(['orange', 'blue', 'white', 'light-blue']),
  /**
   * Is this an outline buttion?
   */
  outLine: PropTypes.bool,
  /**
   * Is this a text button?
   */
  textButton: PropTypes.bool,
  /**
   * Different button states
   */
  state: PropTypes.oneOf(['default', 'hover', 'pressed', 'disabled']),
  /**
   * Apply contained button styling
   */
  contained: PropTypes.bool,
  /**
   * What goes in the button
   */
  children: PropTypes.node,
  /**
   * If set this will be a link and not a button
   */
  href: PropTypes.string,
  /**
   * Is the button disabled?
   */
  disabled: PropTypes.bool,
  type: PropTypes.string,
  /**
   * Additional CSS class names for custom styling.
   */
  className: PropTypes.string,
  /**
   * Display loader
   */
  loading: PropTypes.bool,
};
